import { Box, Grid, GridItem } from "@project/ui";
import { Tags } from "@/components/tags";
import type { PageArticleFieldsFragment } from "@/lib/contentful/__generated/graphql.types";
import { ArticleTopicDateComponent } from "./article-topic-date-component";
import { HeroTitleComponent } from "@/components/hero-layouts/hero-title-component";
import { ArticleReadingTimeComponent } from "./article-reading-time-component";

type ArticleTitleDefaultProps = PageArticleFieldsFragment & {
    readingTime: number;
};

export const ArticleTitleDefault = (props: ArticleTitleDefaultProps) => {
    const { title, readingTime, tagsCollection, ...restProps } = props;

    return (
        <Box color="allWhite" pb={{ base: 12, l: 12 }}>
            <HeroTitleComponent
                title={title}
                isLight={false}
                overTitleComponent={<ArticleTopicDateComponent {...restProps} />}
            />
            <Grid
                templateColumns={{ base: "repeat(2, 1fr)", l: "repeat(6, 1fr)" }}
                gap={{ base: 5, l: 10 }}
                mt={{ base: 5, l: 10 }}
            >
                <GridItem colStart={1} colEnd={3}>
                    <ArticleReadingTimeComponent readingTime={readingTime} />
                </GridItem>
                {tagsCollection?.items.length ? (
                    <GridItem colStart={1} colEnd={{ base: 3, l: 6 }}>
                        <Tags tagsCollection={tagsCollection.items} />
                    </GridItem>
                ) : null}
            </Grid>
        </Box>
    );
};
